import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll

export default {
    scrollTo(el, speed = 1, offset = 0) {
        scroll.animateScroll(el, null, {
            speed: speed * 1000,
            offset
        })
    }
}
